import React, { Component } from 'react'
import { testDashedDateFormat, getDatetime } from './../../utils/js/time_helpers'
import { broadcast_api_url } from './../../utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'
import { fireAnalytics } from './../../utils/js/analytic_helpers'
import axios from 'axios'
import { debounce } from '../../utils/js/debounce'
import Events from './Events'
import BigBox from '../../components/ad_types/BigBox'
import FindMyChannels from './FindMyChannels'
import Helmet from 'react-helmet'
import CalReply from '../../components/calreply/CalReply'
import DatePicker from 'components/date_picker/DatePicker'
import RadioStations from '../../components/radio_stations/RadioStations'
import store from '../../store'
import Feedbackify from './../../components/feedback/Feedback'
import { withRouter } from 'react-router-dom'

import './Schedule.scss'

class Schedule extends Component {
    constructor(props) {
        super(props)
        this.mounted = false
        this.source = null

        const url_date =
            props.match.params.day !== undefined
                ? testDashedDateFormat(props.match.params.day)
                : null

        this.state = {
            dateObj: url_date ? new Date(url_date.replace(/-/g, '/') + ' 00:00:00') : new Date(),
            dashedDate: url_date || '',
            isFetching: true,
            isError: false,
            events: [],
            channels: [],
        }
    }

    componentDidMount() {
        store.dispatch({
            type: 'ANALYTIC_EVENT_PAGE',
            naming: {
                page: 'broadcast schedule',
                url: window.location.href || document.URL,
            },
        })

        this.mounted = true

        const channels = JSON.parse(localStorage.getItem('channels'))
        this.setState({ channels })

        this.getSchedule(this.state.dateObj, this.state.dashedDate)
    }

    componentWillUnmount() {
        this.mounted = false
        if (this.source) this.source.cancel()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.day !== this.props.match.params.day) {
            const url_date =
                this.props.match.params.day !== undefined
                    ? testDashedDateFormat(this.props.match.params.day)
                    : null

            let date_obj = url_date
                ? new Date(url_date.replace(/-/g, '/') + ' 00:00:00')
                : new Date()
            let dashed_date = this.props.match.params.day ? this.props.match.params.day : ''

            this.getSchedule(date_obj, dashed_date)
        }
    }

    sortEventsByTimestampAndPos = (ob1, ob2) => {
        // Sort by timestamp first
        if (ob1.start_time_utc > ob2.start_time_utc) {
            return 1
        } else if (ob1.start_time_utc < ob2.start_time_utc) {
            return -1
        }

        // Else sort by position
        if (ob1.position < ob2.position) {
            return -1
        } else if (ob1.position > ob2.position) {
            return 1
        } else {
            return 0
        }
    }

    sortFeaturedEventsFirst = ob1 => {
        // Featured games trump all others
        if (ob1.priority_level === 'Featured') {
            return -1
        }
    }

    sortFeaturedEventsByTimestampAndPos = (ob1, ob2) => {
        if (ob1.priority_level === 'Featured') {
            if (ob1.start_time_utc > ob2.start_time_utc) {
                return 1
            } else if (ob1.start_time_utc < ob2.start_time_utc) {
                return -1
            }

            // Else sort by position
            if (ob1.position < ob2.position) {
                return -1
            } else if (ob1.position > ob2.position) {
                return 1
            } else {
                return 0
            }
        }
    }

    removeEvents = events => {
        let time_now = Math.floor(Date.now() / 1000)

        // dont add event if it is 2 hours after end time or low priority
        return events.length !== 0
            ? events.filter(
                  event =>
                      time_now - event.end_time_utc < 7200 &&
                      event.priority_level !== 'Low' &&
                      event.priority_level !== 'Low - Replay Only' &&
                      !event.hidden
              )
            : []
    }

    getSchedule = debounce((date_obj, dashed_date) => {
        const { channels } = this.state

        if (this.source) this.source.cancel()
        if (!this.state.isFetching)
            this.setState({
                isFetching: true,
                isError: false,
                events: [],
                dateObj: date_obj,
                dashedDate: dashed_date,
            })

        this.source = axios.CancelToken.source()

        const start = Math.floor(new Date(date_obj).setHours(0, 0, 0, 0) / 1000)
        const end = Math.floor(new Date(date_obj).setHours(23, 59, 59, 999) / 1000)

        // we set activityfilter to true below so that live games that extend into the next day are visible on that day as well
        axios
            .get(`${broadcast_api_url}/events?day_start=${start}&day_end=${end}&sort=desc`, {
                cancelToken: this.source.token,
                headers: { 'Content-Type': 'application/json' },
            })
            .then(response => {
                if (this.mounted) {
                    let events = response.data.data || []
                    events = this.removeEvents(events)

                    this.setState({
                        events: events
                            .sort(this.sortEventsByTimestampAndPos)
                            .sort(this.sortFeaturedEventsFirst)
                            .sort(this.sortFeaturedEventsByTimestampAndPos),
                        isFetching: false,
                        isError: false,
                        channels: channels || [],
                    })
                }
                this.source = null
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.setState({
                        events: [],
                        isFetching: false,
                        isError: true,
                        channels: [],
                    })
                }
                this.source = null
                handleError(error)
            })
    }, 100)

    addChannels = channels => {
        localStorage.setItem('channels', JSON.stringify(channels))
        this.setState({
            channels: channels || [],
        })
    }

    changeDate = date => {
        let unix_date = date.getTime() / 1000
        let dashed_date = getDatetime(unix_date, 'dashed')

        this.props.history.replace(`/schedule/${dashed_date}`)

        fireAnalytics(
            'day select',
            'date picker',
            0,
            'https://watch.sportsnet.ca/schedule/tvlistings',
            'Schedule Grid',
            'ANALYTIC_EVENT_BROADCAST_SCHEDULE'
        )
    }

    render() {
        return (
            <div className="Schedule__cont">
                <Helmet
                    title={`Broadcast Schedule - Sportsnet.ca`}
                    link={[
                        {
                            rel: 'canonical',
                            href: `${window.location.origin}/schedule`,
                        },
                    ]}
                />
                <div className="inner_cont">
                    <div className="left_col">
                        <div className="date_row__cont">
                            <div className="datepicker__wrapper">
                                <DatePicker
                                    date={this.state.dateObj}
                                    onDateChange={this.changeDate}
                                />
                            </div>
                            <a
                                href="https://watch.sportsnet.ca/schedule/tvlistings"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() =>
                                    fireAnalytics(
                                        'full schedule',
                                        'schedule',
                                        0,
                                        'https://watch.sportsnet.ca/schedule/tvlistings',
                                        'Schedule Grid',
                                        'ANALYTIC_EVENT_BROADCAST_SCHEDULE'
                                    )
                                }
                                className="schedule_grid_btn"
                            >
                                Schedule Grid
                            </a>
                        </div>
                        {!this.state.isError && (
                            <Events
                                events={this.state.events}
                                channels={this.state.channels}
                                dateTimestamp={this.state.dateObj.getTime() / 1000}
                                isFetching={this.state.isFetching}
                            />
                        )}
                        {this.state.isError && (
                            <div className="schedule_error">
                                Unfortunately, An Error Has Occurred. Please Try Again.
                            </div>
                        )}
                        <FindMyChannels addChannels={this.addChannels} />
                    </div>
                    <div className="right_col">
                        <div className="promo_image">
                            <a
                                href="https://www.sportsnetplus.ca?utm_source=sportsnet&utm_medium=editorial&utm_campaign=all&utm_term=conv&utm_content=schedule"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={`https://d2bdydtb2u2ki3.cloudfront.net/broadcast_schedule/schedule_promo1.png`}
                                    alt=""
                                />
                            </a>
                        </div>
                        <BigBox bg={false} view={'all'} visible={true} refresh={false} />
                        <RadioStations />
                        <CalReply type="multileague" />
                    </div>
                </div>
                <Feedbackify formId="14638" />
            </div>
        )
    }
}

export default withRouter(Schedule)
